import { Fragment } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { publicRoutes, privateRoutes } from './routes';
import DefaultLayout from './layouts/DefaultLayout';
import './App.css';
import { ToastContainer } from 'react-toastify';
import { useAxiosInterceptor } from './utils/httpRequest';
import ScrollToTop from './components/Scroll/ScrollToTop';

function App() {
    useAxiosInterceptor();
    const location = useLocation();

    const user = localStorage.getItem('userInfo');

    return (
        <div className="App">
            <ScrollToTop />
            <ToastContainer />
            <Routes location={location}>
                {publicRoutes.map((route, index) => {
                    const Page = route.component;
                    let Layout = DefaultLayout;
                    if (route.layout) {
                        Layout = route.layout;
                    } else if (route.layout === null) {
                        Layout = Fragment;
                    }

                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                <Layout>
                                    <Page />
                                </Layout>
                            }
                        />
                    );
                })}

                {user &&
                    privateRoutes.map((route, index) => {
                        const Page = route.component;
                        let Layout = DefaultLayout;
                        if (route.layout) {
                            Layout = route.layout;
                        } else if (route.layout === null) {
                            Layout = Fragment;
                        }

                        return (
                            <Route
                                key={index}
                                path={route.path}
                                element={
                                    <Layout>
                                        <Page />
                                    </Layout>
                                }
                            />
                        );
                    })}

                {user && <Route path="/" element={<Navigate to="/folder" replace />} />}

                {/* Điều hướng mặc định */}
                <Route path="*" element={<Navigate to="/404" />} />
            </Routes>
        </div>
    );
}

export default App;
